import { render, staticRenderFns } from "./CrmProfileEdit.vue?vue&type=template&id=b430f6be&scoped=true"
import script from "./CrmProfileEdit.vue?vue&type=script&lang=js"
export * from "./CrmProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./CrmProfileEdit.vue?vue&type=style&index=0&id=b430f6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b430f6be",
  null
  
)

export default component.exports